import type { TourConfig } from '../../types/tour.types'

const peopleSearchTour: TourConfig = {
  id: 'people-search',
  title: 'Find the right people',
  module: 'Prospecting',
  routeName: 'PeopleSearch',
  order: 3,
  autoStart: true,
  steps: [
    {
      id: 'intro',
      title: 'Reach decision-makers, not gatekeepers',
      body: 'People Search finds the **actual humans** who can say yes — by title, seniority, department and company. Talking to the right person is the single biggest lever on your reply rate.',
    },
    {
      id: 'filters',
      target: '.people-search-view__content',
      placement: 'top',
      title: 'Target by role, not just company',
      body: 'Combine job titles and seniority with your company filters so every contact is **someone worth emailing**. Narrow now to save export credits later.',
    },
    {
      id: 'ai',
      target: '.people-search-view__content',
      placement: 'top',
      title: 'Let the AI find them for you',
      body: 'Not sure which titles to target? Describe who you sell to and let the assistant assemble the contact list.',
      aiAction: {
        prompt: 'Find the best job titles and contacts to reach for my product and build a people list.',
        label: 'Find contacts with AI',
      },
    },
  ],
}

export default peopleSearchTour
